import { render } from "./CardProdutoReceita.vue?vue&type=template&id=6f224afa&scoped=true"
import script from "./CardProdutoReceita.vue?vue&type=script&lang=js"
export * from "./CardProdutoReceita.vue?vue&type=script&lang=js"

import "./CardProdutoReceita.vue?vue&type=style&index=0&id=6f224afa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f224afa"]])

export default __exports__